var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 0.00244141L28.3885 16.586H45.8255L31.7187 26.8353L37.5002 43.9979L23.0002 33.1696L8.89331 43.4188L14.2816 26.8353L0.174805 16.586H17.6118L23.0002 0.00244141Z",
    fill: "#AD8D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTen);
export default __webpack_public_path__ + "static/media/ten.18e4f86a4cf6bd5d5bf4a71a8be46549.svg";
export { ForwardRef as ReactComponent };